import { format, parse } from 'date-fns';

export function convertDateFormat(dateStr: string): string {
  const [day, month, year] = dateStr.split(' ')[0].split('-');
  if (Number(month) > 12) {
    return dateStr;
  }
  const time = dateStr.split(' ')[1];
  return `${year}-${month}-${day} ${time}`;
}

export function formatTimeZoneDate(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  const inputDate = new Date(year, month - 1, day);
  return inputDate;
}

export function normalizeDate(dateString: string): string {
  const format1 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
  const format2 = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;

  if (format1.test(dateString)) {
    return dateString;
  }
  if (format2.test(dateString)) {
    const parsedDate = parse(dateString, 'dd-MM-yyyy HH:mm:ss', new Date());
    return format(parsedDate, 'yyyy-MM-dd HH:mm:ss');
  }
  return dateString;
}

export function convertSpanishDateToISO(dateString: string): string | null {
  const monthsMap: { [key: string]: string } = {
    ene: '01',
    feb: '02',
    mar: '03',
    abr: '04',
    may: '05',
    jun: '06',
    jul: '07',
    ago: '08',
    sep: '09',
    oct: '10',
    nov: '11',
    dic: '12',
  };

  const dateParts = dateString.split('/');
  if (dateParts.length !== 3) {
    return null;
  }

  const day = dateParts[0].padStart(2, '0');
  const month = monthsMap[dateParts[1].toLowerCase()];
  const year = dateParts[2];

  if (!month || isNaN(Number(day)) || isNaN(Number(year))) {
    return null;
  }

  return `${year}/${month}/${day}`;
}
